<template>
    <div class="Gift_center ">
        <indexTitle english_title="Gift Giving Event" chinese_title="看展送禮活動"  page='true'></indexTitle>
        <listbox :listbox='listbox' row="width:25%"></listbox>
        <div v-show="listbox.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
            <img src="../../assets/loading.gif">
        </div>
        <moreButton button_text="返回首頁" button_href="/"></moreButton>
    </div>
</template>
<script>
import IndexTitle from '@/components/index/IndexTitle'
import listbox from '@/components/list/listbox'
import MoreButton from '@/components/index/MoreButton'
export default {
    components: {
        'indexTitle': IndexTitle,
        'listbox':listbox,
        'moreButton': MoreButton,
    },
    metaInfo: {
      title: '送禮活動 │ TopLink 上聯國際展覽有限公司', // set a title
      meta: [{                 // set meta
        name: 'description',
        keywords: '上聯,展覽,好康,送禮,折價券,抽獎',
        content: '上聯國際展覽會員專屬好康，凡特定期間預約看展將贈送展覽限定好禮，有:早鳥禮、看展抽、折價券、滿額禮、參加獎…等，數量有限送完為止。'
      }]
    },
    data(){
        return{
            listbox:[],
        }
    },
    computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
    created(){
    var vm = this;
     var gift_api = vm.API + 'api/tlweb/activity'
    // axios.get('http://localhost/api/tlweb/activity')
    this.axios.get(gift_api)
      .then(function (response) {
        vm.listbox = response.data.data.data
        // console.log(vm.listbox);
      })
      .catch(function (error) {
        console.log(error);
      });
    }
    
}
</script>
<style>
.Gift_center{
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
}
</style>


